<template>
    <b-row>
        <b-col cols=12>
            <b-alert show :variant="color">
                <h3>{{ mensaje }}</h3>
            </b-alert>
        </b-col>
        <b-col cols="12" v-if="error" @click="devolucion">
            <b-button>Intentar de nuevo</b-button>
        </b-col>
        <b-col cols="12" v-if="continuar" @click="$emit('devolucionCorrecta', null);">
            <b-button>Realizar devolución de forma manual</b-button>
        </b-col>
    </b-row> 
</template>

<script>
    import * as Tpvpc from '@/assets/redsys/tpvpc-impl.js'

    export default {
        props: {
            importe: {
                required: true,
                type: Number
            },
            pedido: {
                required: true,
                type: String
            },
            rts: {
                required: true,
                type: String
            },
            datafono_id: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                datafono: null,
                error: false,
                color: 'primary',
                mensaje: 'Iniciando datafono...',
                continuar: false
            }
        },
        created() {
            if(this.datafono_data) {
                this.datafono = new Tpvpc.TpvpcImplantado();
                this.datafono.EnableLog();

                this.init(this.datafono_data.comercio, this.datafono_data.terminal.toString(), this.datafono_data.key);
            } else {
                this.color = 'danger';
                this.mensaje = 'Este usuario no tienen ningún datafono asignado.';
            }        
        },
        computed: {
            datafono_data() {
                if(this.$store.getters.getUser.datafonos) {
                    return this.$store.getters.getUser.datafonos.find(datafono => datafono.id == this.datafono_id);
                }
            },
        },
        methods: {
            init(comercio, terminal, key) {
                this.datafono.initFnDll([comercio, terminal, key, '', ''], ret => {
                    if(ret.Response == 0) {
                        this.devolucion();
                    } else {
                        this.continuar = true;
                        this.color = 'danger';
                        this.mensaje = 'Error al conectar con el datafono.'
                    }
                }, comercio)
            },
            devolucion() {
                this.error = false;
                this.color = 'primary';
                this.mensaje = 'Realizando devolución.'
                let importeFormateado = this.importe.toFixed(2);

                this.datafono.execFnDll('fnDllOperComContable', [this.pedido, this.rts, importeFormateado, '', 'DEVOLUCION'], ret => {
                    const response = this.xmlStringToJson(ret.Result);

                    if(response.comunicacionContable && response.comunicacionContable.resultadoComunicacion.resultado == 'Autorizada' && response.comunicacionContable.resultadoComunicacion.estado == 'F') {
                        this.color = 'success';
                        this.mensaje = 'Devolución realizada correctamente.';
                        this.$emit('devolucionCorrecta', response.comunicacionContable.resultadoComunicacion);
                    } else {
                        this.color = 'danger';
                        this.error = true;
                        this.mensaje = response.Error.mensaje;
                    }
                })
            },
            xmlStringToJson(xmlString) {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlString, "text/xml");

                function xmlToJson(xmlNode) {
                    let obj = {};

                    if (xmlNode.attributes) {
                        for (let i = 0; i < xmlNode.attributes.length; i++) {
                            let attribute = xmlNode.attributes.item(i);
                            obj[`@${attribute.nodeName}`] = attribute.nodeValue;
                        }
                    }

                    if (xmlNode.hasChildNodes()) {
                        for (let i = 0; i < xmlNode.childNodes.length; i++) {
                            let childNode = xmlNode.childNodes.item(i);

                            if (childNode.nodeType === 3) {
                                let textValue = childNode.nodeValue.trim();
                                if (textValue) {
                                    obj = textValue;
                                }
                            } else {
                                let nodeName = childNode.nodeName;
                                if (typeof obj[nodeName] === "undefined") {
                                    obj[nodeName] = xmlToJson(childNode);
                                } else {
                                    if (!Array.isArray(obj[nodeName])) {
                                        obj[nodeName] = [obj[nodeName]];
                                    }
                                    obj[nodeName].push(xmlToJson(childNode));
                                }
                            }
                        }
                    }

                    return obj;
                }

                return xmlToJson(xmlDoc.documentElement);
            }
        }
    }
</script>